

<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>







<div class="card" *ngIf="ShowCard===2">
  <div class="card-body">
<br>
    <div class="row">
      <p style="color: #6ab187;"><strong>EMPLOYEE SCREENING</strong></p>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/users.png"><a style="text-decoration: none;color:black" routerLink="/whitecollar"> <strong class="white">&nbsp; White-collar verification</strong></a></div>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/mechanic.png"><a style="text-decoration: none;color: black;"  routerLink="/bluecollar"><strong class="white"> Blue-collar verification</strong></a></div>
      <br><br>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/online-business.png"><a style="text-decoration: none;color: black;" routerLink="/gigworker"> &nbsp;<strong class="white"> Gig Worker verification</strong></a></div>
    </div>
    <br>
    
    <div class="row">
      
      <p style="color: #6ab187;"><strong>RISK & COMPLIANCE</strong></p>
      <div class="col-3"><img style="width: 30px;height: auto;" src="assets/risktopicon.png"><a style="text-decoration: none;color: black;" routerLink="/riskmanage"><strong class="white"> Risk Management</strong></a></div>
      <div class="col-3"><img style="width: 35px;height: auto;" src="assets/onboarding.png"><a style="text-decoration: none;color: black;" routerLink="/vendor"><strong class="white" > Vendor Onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/distributortopicon.png"><a style="text-decoration: none;color: black;" routerLink="/distribute"><strong class="white"> Distributor onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/duediligence.jpg"><a style="text-decoration: none;color: black;" routerLink="/duediligence"><strong class="white"> Due Diligence</strong> </a></div>
    </div>
    <br>
  
    <!--  -->
    <div class="row">
      
      <p style="color: #6ab187;"><strong> FINANCIAL INTELLIGENCE</strong></p>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/kycsolution.png"><a style="text-decoration: none;color: black;" routerLink="/kycsolution"><strong class="white"> KYC solutions</strong> </a></div>
    </div>
    <br>
  
  </div>
</div>


<div class="card" *ngIf="ShowCard===1">
  <div class="card-body">
<br>
<p style="color: #6ab187;font-weight: 600;"><strong>PRODUCT</strong></p>

    <div class="row">
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" (click)="ShowCard=3"><strong class="white"><img style="width: 4%;height: 100%;" src="assets/docverify.png"> Document Verification</strong> </a></div>
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" routerLink="/service"><strong class="white"><img style="width: 5%;height: 110%;" src="assets/docsignin.png"> Document SignIn</strong> </a></div>
  
    </div>
    <br>

    <div class="row">
       </div>
    <br>
    
  </div>
</div>


<!--  -->

<div class="card" *ngIf="ShowCard===3">
  <div class="card-body">
    <br>
<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/aadhartopicon.png"><a style="text-decoration: none;color: black;" routerLink="/aadhaar"> <strong class="white"> Aadhaar verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/pantopicon.png"><a style="text-decoration: none;color: black;"  routerLink="/pan"><strong class="white"> Pan verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/gsttopicon.jpg"><a style="text-decoration: none;color: black;" routerLink="/gst"><strong class="white"> Gst verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/drivinglicensetop.jpg"><a style="text-decoration: none;color: black;" routerLink="/driving"><strong class="white"> Driving verification</strong></a></div>
</div><br><br>

<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/passporttopicon.png"><a style="text-decoration: none;color: black;" routerLink="/passport"><strong class="white"> Passport verification</strong> </a></div>
  <div class="col"><img style="width: 58px;height: 44px;" src="assets/rcverify.png"><a style="text-decoration: none;color: black;" routerLink="/rcverify"><strong class="white"> RC verification</strong></a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/msmeverify.png"><a style="text-decoration: none;color: black;" routerLink="/msmeverify"><strong class="white"> MSME verification</strong> </a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/verification.png"><a style="text-decoration: none;color: black;" routerLink="/dinverify"><strong class="white"> DIN verification</strong></a></div>
</div>

<br><br>
<div class="row">
  <div class="col-3"><img style="width: 35px;height: 44px;border-radius: 20px;" src="assets/cinicon.png"><a style="text-decoration: none;color: black;" routerLink="/cinverify"><strong  class="white"> CIN verification</strong></a></div>
</div>
</div>
</div>



<br><br>



<div class="row" data-aos="zoom-in" data-aos-delay="300">
  <div class="col-md-6  text-center">
    <img style="width:70%;height: 90%;margin-top:10%;border-radius:40px;box-shadow: 50px 20px #76b891;" src="assets/bluecollarverify.jpg">
</div>
    <div style="padding-top: 10%;" class="col-md-6">
        <h1>
            <span class="topic">Empowering Business with the Ultimate Blue Collar Verification Solution</span>
          </h1>
        <h5 style="padding-left: 10%;">&nbsp;&nbsp;&nbsp;One-stop solution for securing a reliable, skilled, and trustworthy blue-collar workforce</h5>
    </div>

   
</div>
<br><br>
<br><br><br>

<div class="row" data-aos="zoom-in" data-aos-delay="300">
    <div class="col-md-12">
        <h1 style="color: #6ab187;text-align: center;">Overcoming the Challenges with <br>Blue Collar Verification</h1>
        <br>
        <p style="text-align: center;">Easiest, most flexible, and most delightful employment background check experience</p>


           <br><br>
<div  class="row p-2">

    <div style="background-color: #eff8ff;"  class="col-md-4 ">
        <br>
        <img style="width: 130px;height: 65px;background-color: #eff8ff;" src="assets/identitymisrep.png">
       <br><br><br>
        <h5>Identity Misrepresentation</h5>
        <p style="align-items: center;">Check for the genuineness of the blue collar workforce to safeguard your business from the risk of identity theft.</p>
    </div>
  
    <div style="background-color: #c9d9e6;" class="col-md-4">
          <br>
          <img style="width: 90px;height: 90px;" src="assets/safetyconcerns.png">
         <br><br>
          <h5 >Safety Concerns</h5>
          <p style="align-items: center;">Insufficient screening can expose your business to potential safety hazards by hiring individuals with criminal records or disciplinary issues.</p>
      </div>
     
      <div  style="background-color: #eff8ff;" class="col-md-4">
     
        <br>
        <img style="width: 70px;height: 70px;" src="assets/highturnover.jpg">
       <br><br><br>
        <h5>High Turnover</h5>
        <p style="align-items: center;">Inadequate screening leads to higher turnover rates, adding unnecessary costs and disruptions to your operations.<p>
    </div>
  </div>
    </div>
</div>

<br><br><br>
<div class="row p-2" data-aos="fade-up" data-aos-delay="300"   >
    <div  class="col">
        <h2 style="color: #6ab187;text-align: center;">The Process of Blue Collar Verification</h2>

        <br><br>
  <div  class="row ">

    <div   class="col-md-3">
        <br>
        <img style="height: 65px;" src="assets/collecting.png">
       <br><br><br>
        <h5>STEP 1</h5>
        <p style="align-items: center;">Collecting PoI and PoA documents (Aadhaar card, Voter ID card, electricity bill, etc)</p>
    </div>
  
    <div class="col-md-3">
          <br>
          <img style="width: 80px;height: 80px;" src="assets/ocrverify.png">
         <br><br>
          <h5>STEP 2</h5>
          <p style="align-items: center;">OCR based extraction to run real-time check</p>
      </div>
     
      <div class="col-md-3">
     
        <br>
        <img style="width: 70px;height: 60px;" src="assets/scanface.jpg">
       <br><br><br>
        <h5 >STEP 3</h5>
        <p style="align-items: center;">Worker clicks a selfie and we matches that with the photo on ID document<p>
    </div>

    <div class="col-md-3">
     
        <br>
        <img style="width: 60px;height: 60px;" src="assets/verifyicon.png">
       <br><br><br>
        <h5 >STEP 4</h5>
        <p style="align-items: center;">The verification is done. In case of insufficiency, the worker can re-upload.<p>
    </div>
  
  </div>
    </div>
</div>

<br><br>
<div class="row" data-aos="zoom-in" data-aos-delay="300"  >
    <div class="col">
        <h3 style="color: #6ab187;text-align: center;">Blue Collar Workforce</h3>
        <h2 style="text-align: center;">Unlocking the Power of Trust with <br>Facheck's Blue Collar Screening Solution</h2><br>
        <p style="text-align: center;">Comprehensive blue collar screening solution to help you build a team that will drive your success.</p>
    </div>
</div>

<br><br>

<div class="row p-2"  data-aos="fade-up" data-aos-delay="300">
    <div class="col-md-6">
        <br>
        <img style="width: 37px;height: 32px" src="assets/comprehensive.png">
        <span style="color: #6ab187;">Comprehensive</span><br>
        <h3 style="text-align: start;color: #6ab187;">Full-Scale Screening Solutions</h3>
        <p >A wide range of blue collar verification services tailored to meet the demands of the business. From criminal background checks and drug testing to license verification and skills assessments, our solutions leave no stone unturned in ensuring you hire the right blue-collar workforce.</p>
    </div>

    <div class="col-md-6 text-center">
        <img style="width: 80%;height: 100%;" src="assets/comprehensivesolution.png">
    </div>
    </div>

<br><br><br><br>
<div class="row p-2"  data-aos="fade-up" data-aos-delay="300" >
 
    <div class="col-md-6 text-center">
        <img src="assets/consolidatedview (2).png">
    </div>

    <div class="col-md-6">
        <img style="width: 37px;height: 37px;" src="assets/degreeview.jpg">
        <span style="color: #6ab187;height: 20%;">360 degree view</span>
        <h3 style="text-align: start;color: #6ab187;">Consolidated View of Blue-Collar Verifications.</h3>
        <p  > Have complete visibility of your blue collar verification status on one screen. Know how many workers have not started the verification process or how many cases are still pending and completed. Graphical representation of all the verification information for easy consumption.</p>
    </div>
</div>
<br><br><br><br>


<div class="row p-2" data-aos="fade-up" data-aos-delay="300" >
    <div class="col-md-6 ">
        <br>
        <img style="width: 37px;height: 37px" src="assets/optimize.png">
        <span style="color: #6ab187;">Optimize</span><br>
        <h3 style="text-align: start;color: #6ab187;">Automate & Standardize your Verification Process</h3>
        <p >Do away with manual entry of documents in different languages leading to complete data discrepancy across the database. Automate the blue-collar onboarding and verification process for a seamless and chaos free experience.</p>
    </div>

    <div class="col-md-6 text-center">
        <img style="width: 70%;height: 90%;" src="assets/automatestandard.png">
    </div>
    </div>



    
<br><br><br><br>
<div class="row p-2" data-aos="fade-up" data-aos-delay="300" >
 
    <div class="col-md-6 text-center">
        <img style="width: 80%;height: 90%" src="assets/custsupp.png">
    </div>

    <div class="col-md-6">
        <img style="width: 37px;height: 37px;" src="assets/assistant.png">
        <span style="color: #6ab187;height: 20%;">Assistance</span>
        <h3 style="text-align: start;color: #6ab187;">Unrivaled Customer Support</h3>
        <p >From pre-onboarding to post-onboarding, we are there with you every step of the way. All time assistance to tutorial videos and FAQs, we are here to make the process a breeze for your HR and recruitment teams along with the blue collar employees</p>
    </div>
</div>




<br><br><br>
<div class="row" data-aos="zoom-in" data-aos-delay="300">
    <div class="col">
        <h3 style="text-align: center;color: #6ab187;">Background Verification Checks for Blue Collar Employee Screening</h3>
        <p style="text-align: center;">Authenticate your blue-collar workforce verification with extensive verification checks</p>
    </div>

</div>
<br><br>

<div  class="row p-2 text-center" data-aos="fade-up" data-aos-delay="300"   >
    <div class="col-md-3 mt-2">
        <div  class="card" style="height: 200px;" >
            <div class="card-body">
    
                <img style="width: 34%;height:30%" src="assets/courtcheck.jpg">
<br><br>
              <h5 class="card-title">Court Record Check</h5>
            </div>            
          </div>
    </div>

    <div class="col-md-3 mt-2">
      <div class="card" style="height: 200px;" >
          <div class="card-body">
              <img style="width: 34%;height:30%" src="assets/voteridchecks.png">
           <br><br>
            <h5 class="card-title">Aadhaar verification</h5><br>
          </div>            
        </div>
  </div>

  <div class="col-md-3 mt-2">
    <div class="card" style="height: 200px;" >
        <div  class="card-body">

            <img style="width: 30%;height:30%" src="assets/panchecks.png">
            <br><br>
          <h5 class="card-title">Pan card verification</h5>
<br>
        </div>            
      </div>
</div>

<div class="col-md-3 mt-2">
  <div class="card" style="height: 200px;" >
      <div class="card-body">
          <img style="width: 34%;height:30%"  src="assets/voterid.jpg">
          <br><br>
        <h5 class="card-title">Voter Id Verification</h5>

      </div>            
    </div>
</div>

  </div>
  <br><br>


<div  class="row p-2 text-center" data-aos="fade-up" data-aos-delay="300">
    <div class="col-md-3 mt-2">
        <div  class="card" style="height: 200px;" >
            <div class="card-body">
    
                <img style="width: 34%;height:30%" src="assets/rcverifyicon.png">
<br><br>
              <h5 class="card-title">Police Verification</h5>
            </div>            
          </div>
    </div>

    <div class="col-md-3 mt-2">
      <div class="card" style="height: 200px;" >
          <div class="card-body">
              <img style="width: 34%;height:30%" src="assets/drugtest.jpg">
<br><br>
            <h5 class="card-title">Drug test</h5><br>
          </div>            
        </div>
  </div>

  <div class="col-md-3 mt-2">
    <div class="card" style="height: 200px;" >
        <div  class="card-body">

            <img style="width: 30%;height:30%" src="assets/addressverify.png">
            <br><br>
          <h5 class="card-title">Address Verification</h5>
        </div>            
      </div>
</div>

<div class="col-md-3 mt-2">
  <div class="card"  style="height: 200px;">
      <div class="card-body">
          <img style="width: 34%;height:30%"  src="assets/drivinglicenseim.jpg">
          <br><br>
        <h5 class="card-title">Driving License</h5>
<br>
      </div>            
    </div>
</div>

  </div>

  <br><br>

  <div  class="row p-2 text-center" data-aos="fade-up" data-aos-delay="300">
      <div class="col-md-3 mt-2">
          <div  class="card" style="height: 200px;" >
              <div class="card-body">
      
                  <img style="width: 34%;height:30%" src="assets/rcver.jpg">
  <br><br>
                <h5 class="card-title">RC verify</h5>
              </div>            
            </div>
      </div>
  
      <div class="col-md-3 mt-2">
        <div class="card" style="height: 200px;" >
            <div class="card-body">
                <img style="width: 34%;height:30%" src="assets/referencecheck.jpg">
             <br><br>
              <h5 class="card-title">Professional Reference check</h5>
            </div>            
          </div>
    </div>
  
    <div class="col-md-3 mt-2">
      <div class="card" style="height: 200px;" >
          <div  class="card-body">
  
              <img style="width: 30%;height:30%" src="assets/electricbill.png">
              <br><br>
            <h5 class="card-title">electricity bill</h5>
  <br>
          </div>            
        </div>
  </div>
  
  <div class="col-md-3 mt-2">
    <div class="card" style="height: 200px;" >
        <div class="card-body">
            <img style="width: 34%;height:30%"  src="assets/faceverify.jpg">
            <br><br>
          <h5 class="card-title">Face Verification</h5>
  
        </div>            
      </div>
  </div>
  
    </div>
    

 
<br><br><br>





